import { getRolePrefix } from "./apiConfig";
export const API_BASE_URL =
  "https://api.learninsight.in/api/v1/";

// export const API_BASE_URL =
//   "http://localhost:5100/api/v1/";



// export const API_BASE_URL =
//   "https://kyapi.octaloptimum.in/api/v1/";


export const API_PATHS = {

  institutelogin: "institute/login",
  superadminlogin: "super-admin/login",
  institutelogout: "institute/logout",
  adminuploadFile: "institute/upload-file",
  getDashCount: "institute/get-dash-count",
  teacheruploadFile: "teacher/upload-file",

  sadminuploadFile: "super-admin/upload-file",

  //institute
  addInstitute: "super-admin/add-institute",
  getInstitute: "super-admin/get-institute",

  //staff
  getStaff: "institute/get-staff",
  addStaff: "institute/add-staff",
  editStaff: "institute/edit-staff",
  deleteStaff: "institute/delete-staff",



  getGrade: "institute/get-grade",
  addGrade: "institute/add-grade",
  editGrade: "institute/edit-grade",
  deleteGrade: "institute/delete-grade",

  // student

  addStudent: "institute/add-student",
  editStudent: "institute/edit-student",
  deleteStudent: "institute/delete-student",


  //class section
  getSection: "institute/get-section",
  getStandard: "institute/get-standard",
  getClassSection: "institute/get-standard-section",
  addClassSection: "institute/add-standard-section",
  editClassSection: "institute/edit-standard-section",

  //class subject
  getClassSubject: "institute/get-standard-subject",
  addClassSubject: "institute/add-standard-subject",
  editClassSubject: "institute/edit-standard-subject",

  //class teacher
  addclassteacher: "institute/add-class-teacher",
  editclassTeacher: "institute/edit-class-teacher",
  deleteclassTeacher: "institute/delete-class-teacher",

  //  subject 
  addSubject: "institute/add-subject",
  editSubject: "institute/edit-subject",
  deleteSubject: "institute/delete-subject",
  getSubject: "institute/get-subject",
  getclassSubjects: "institute/get-class-subject",
  getexamSubjects: "institute/get-exam-class-subject",
  addclassSubjects: "institute/add-class-subject",
  editclassSubjects: "institute/edit-class-subject",
  addexamSubjects: "institute/add-exam-class-subject",
  editexamSubjects: "institute/edit-exam-class-subject",

  addStandardfees: "institute/add-fees",
  editStandardfees: "institute/edit-fees",

  setMarks: "institute/set-marks",

  editSetMarks: "institute/edit-set-marks",

  deleteSetMarks: "institute/delete-set-marks",

  getclassSubjectsstudent: "student/get-class-subject",

  generateReportCard: "institute/generate-reportcard",


  //subject teacher
  addsubjectteacher: "institute/add-subject-teacher",
  deletesubjectTeacher: "institute/delete-subject-teacher",


  //notice

  addNotice: "institute/add-notice",
  editNotice: "institute/edit-notice",
  deleteNotice: "institute/delete-notice",

  //holiday

  addHoliday: "institute/add-holiday",
  editHoliday: "institute/edit-holiday",
  deleteHoliday: "institute/delete-holiday",

  getFeeCollection: "institute/get-fees-collection",
  addFeeCollection: "institute/add-fee-collection",
  addtransportFeeCollection: "institute/add-transport-fee-collection",

  gettransportReport: "institute/get-transport-report",
  getDemandReport: "institute/get-demand-report",
  getDueReport: "institute/get-due-report",
  getDiscountReport: "institute/get-discount-report",
  addExpense: "institute/add-expense",
  getExpense: "institute/get-expense",

  addRoute: "institute/add-route",
  editRoute: "institute/edit-route",
  getRoute: "institute/get-route",
  deleteRoute: "institute/delete-route",

  getallChild: "student/get-all-child",

  getExam: "teacher/get-exams",
  addResult: "teacher/add-result",
  getResult: "teacher/get-result",


};

export const getApiPaths = (role) => {
  const prefix = getRolePrefix(role);
  return {

    getStandard: `${prefix}/get-standard`,
    getSection: `${prefix}/get-section`,
    getSubject: `${prefix}/get-subject`,

    getStudent: `${prefix}/get-student`,
    getProfile: `${prefix}/get-profile`,


    //fee type
    getfeeType: `${prefix}/get-fee-type`,
    addfeeType: `${prefix}/add-fee-type`,
    editfeeType: `${prefix}/edit-fee-type`,

    getSetMarks: `${prefix}/get-set-marks`,


    getHomework: `${prefix}/get-homework`,
    addHomework: `${prefix}/add-homework`,
    editHomework: `${prefix}/edit-homework`,
    deleteHomework: `${prefix}/delete-homework`,
    getNotice: `${prefix}/get-notice`,
    getHoliday: `${prefix}/get-holiday`,
    getFees: `${prefix}/get-fees`,
    getExam: `${prefix}/get-exam`,
    addExam: `${prefix}/add-exam`,

    getDiaryNote: `${prefix}/get-diary-note`,
    addDiaryNote: `${prefix}/add-diary-note`,
    editDiaryNote: `${prefix}/edit-diary-note`,
    deleteDiaryNote: `${prefix}/delete-diary-note`,

    getNote: `${prefix}/get-notes`,
    addNote: `${prefix}/add-notes`,
    editNote: `${prefix}/edit-notes`,
    deleteNote: `${prefix}/delete-notes`,

    getActivity: `${prefix}/get-activity`,
    addActivity: `${prefix}/add-activity`,
    deleteActivity: `${prefix}/delete-activity`,

    getAttendence: `${prefix}/get-attendance`,
    addAttendence: `${prefix}/add-attendance`,

    getclassTeacher: `${prefix}/get-class-teacher`,
    getsubjectTeacher: `${prefix}/get-subject-teacher`,
    getstudentFeesDetails: `${prefix}/get-student-fees-details`

  };

};
